import axios from "axios";
var urlPrefix = process.env.VUE_APP_OMNI_BASE_URL + "/api";
var securityApiUrlPrefix = process.env.VUE_APP_OMNI_SECURITY_BASE_URL + "/api";

import securityModule from "../Modules/securityModule";

let instance = axios.create({ baseURL: urlPrefix });
instance.interceptors.request.use(function (config) {
  var user = securityModule.state.userProfile;
  config.headers["UserId"] = user?.id;
  config.headers["FirstName"] = user?.firstName;
  config.headers["LastName"] = user?.lastName;
  config.headers["UserEmail"] = user?.email;
  return config;
});

export async function sendFeedbackEmail(data) {
  return axios
    .post(urlPrefix + "/api/shared/sendFeedbackEmail", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function getUserAccess(data) {
  return axios
    .get(securityApiUrlPrefix + "/identity/getUserAccess", {
      params: {
        clientId: data.clientId,
        userId: data.userId,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}

export function getUser(data) {
  return axios
    .get(securityApiUrlPrefix + "/identity/getUser", {
      params: {
        userId: data,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}

export async function get(subURL) {
  return instance
    .get(urlPrefix + subURL)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function getQuery(subURL, data) {
  return instance
    .get(urlPrefix + subURL, {
      params: data,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function post(subURL, data) {
  return instance
    .post(urlPrefix + subURL, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function postQuery(subURL, data) {
  return instance
    .post(urlPrefix + subURL, null, {
      params: data,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function uploadFile(path, params, file) {
  let formData = new FormData();
  formData.append("asset", file);

  return instance
    .post(urlPrefix + path, formData, {
      params,
      "Content-Type": "multipart/form-data",
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}
